<template>
    <div class="__l">
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">Press Releases</h1>
            </div>
            <div>
            </div>
        </div>
        <input type="text" class="form-field py-4 px-6" ref="searchbar" placeholder="Search for press releases by title"
               @keyup.enter="handleSearch">
        <div v-if="results.data && search" class="my-2 text-center">
            <p>The total number of results for <strong>"{{ search }}"</strong> is <strong>{{ results.total }}</strong></p>
        </div>
        <div v-if="results.data && !search" class="my-2 text-center">
            <p>The total number of results is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="40%">Headline</div>
                <div class="results-head" data-width="20%">Business</div>
                <div class="results-head" data-width="10%">Status</div>
                <div class="results-head" data-width="10%">Matched</div>
                <div class="results-head" data-width="10%">Views</div>
                <div class="results-head" data-width="10%">Opens</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectRelease(result)">
                    <div class="results-cell" data-width="10%">{{ result.pr_id }}</div>
                    <div class="results-cell" data-width="40%">{{ result.pr_headline }}</div>
                    <div class="results-cell" data-width="20%" v-if="result.business">{{ result.business.name }}</div>
                    <div class="results-cell" data-width="20%" v-if="!result.business">[Business Removed]</div>
                    <div class="results-cell" data-width="10%">{{ getStatusTextForRelease(result) }}</div>
                    <div class="results-cell" data-width="10%">{{ result.pr_matches }}</div>
                    <div class="results-cell" data-width="10%">{{ result.views.length }}</div>
                    <div class="results-cell" data-width="10%">{{ result.opens.length }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"
                            v-if="results.data"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'Releases',
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination
    },
    mounted() {
        this.loadData()
        this.setMetaTitle('List Press Releases | JournoLink Control')
    },

    beforeRouteUpdate(to, from, next) {
        this.loadData()
        next()
    },
    methods: {
        handleSearch(event) {
            this.search = event.target.value
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('releases.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of a release
         *
         * @param  {Object} release
         * @return {void}
         */
        handleSelectRelease(release) {
            this.$router.push({name: 'releases.show', params: {releaseId: release.pr_id}})
        },
        /**
         * createRelease
         */
        createRelease() {
            this.$router.push({name: 'release.create'})
        },
        /**
         * Return the appropriate status text for the given release
         *
         * @param {Object} release
         * @returns {string}
         */
        getStatusTextForRelease(release) {
            if (release.flags.flagged !== undefined) {
                return 'Flagged'
            }

            return release.status
        }
    },
}
</script>

<style lang="less">

</style>
